export default __webpack_public_path__ + "static/headerUnsupported-c74e58b197913fe0eaea40261b2c9807.jpg";